module.exports = __webpack_public_path__ + "static/media/gtl-bg-green-blur.8868f0ab.jpg";